import { BufferGeometry, NormalBufferAttributes } from 'three';
import { TextureData } from '~/Component/Texture';

/**
 * @return {void}
 */
export function SetUvMap(
    geometry: BufferGeometry<NormalBufferAttributes>,
    data: TextureData,
    which: string): void
{
    geometry.attributes.uv.setXY(0, (data.frames[which].x + data.frames[which].w) / data.meta.size.w, 1); // topright
    geometry.attributes.uv.setXY(1, data.frames[which].x / data.meta.size.w, 1); // topleft
    geometry.attributes.uv.setXY(2, (data.frames[which].x + data.frames[which].w) / data.meta.size.w, 0); // bottom right
    geometry.attributes.uv.setXY(3, data.frames[which].x / data.meta.size.w, 0); // bottom left
    geometry. attributes.uv.needsUpdate = true;
}
